var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    d: "M20 10C20 15.5 15.5 20 10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0C15.5 0 20 4.5 20 10Z",
    fill: "#BF152C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M8.98285 11.9667L8.64951 3.75H11.3162L10.9828 11.9667H8.98285ZM8.49951 14.7C8.49951 13.9 9.16618 13.2333 9.98284 13.2333C10.7828 13.2333 11.4495 13.9 11.4495 14.7C11.4495 15.5167 10.7828 16.1833 9.98284 16.1833C9.16618 16.1833 8.49951 15.5167 8.49951 14.7Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDark);
export default __webpack_public_path__ + "static/media/error-dark.cee0001367ad6aaac91f869501979a31.svg";
export { ForwardRef as ReactComponent };